import { useState, useCallback, ReactNode, useMemo } from "react";
import ReactDOM from "react-dom";
import { useQuery } from "@apollo/client";
import BulkFileUploadPanelContextStore from "./CustomerRFQ.context";
import { CustomerRFQForm, CustomerRFQFormProps } from "./CustomerRFQForm";
import {
  GetUserValidationQuery,
  GetUserValidationQueryResult,
  GetUserValidationQueryVariables,
} from "../../schema/generated/schema";

function RFQOnlyCTA({
  onClick,
  childComponents,
}: {
  onClick: () => void;
  childComponents: ReactNode;
}) {
  return (
    <div tabIndex={0} role="button" onKeyDown={() => false} onClick={onClick}>
      {childComponents}
    </div>
  );
}

const PortaledFormModal = (props: CustomerRFQFormProps) => {
  const formModal = <CustomerRFQForm {...props} />;
  return ReactDOM.createPortal(formModal, document.body);
};

const withRfq = (
  WrappedComponent: React.ComponentType<Record<string, any>>,
  isModalOnly: boolean
) => {
  const hocComponent = ({ ...props }) => {
    const { error, data, loading, refetch } = useQuery<
      GetUserValidationQueryResult,
      GetUserValidationQueryVariables
    >(GetUserValidationQuery);
    const user = useMemo(
      () => (!loading && !error && data ? data.me : null),
      [data, error, loading]
    );
    const [modalIsOpen, setModalIsOpen] = useState(isModalOnly);

    const formProps: CustomerRFQFormProps = {
      isOpen: modalIsOpen,
      userEmail: user?.emailAddress,
      handleClose: () => setModalIsOpen(false),
      refetchUser: refetch,
    };

    if (!isModalOnly) {
      return (
        <BulkFileUploadPanelContextStore userId={user?.id || ""}>
          <PortaledFormModal {...formProps} />
          <WrappedComponent onClick={() => setModalIsOpen(true)} {...props} />
        </BulkFileUploadPanelContextStore>
      );
    }
    return (
      <BulkFileUploadPanelContextStore userId={user?.id || ""}>
        <PortaledFormModal {...formProps} />
      </BulkFileUploadPanelContextStore>
    );
  };
  return hocComponent;
};

export const CustomerQuoteRequest: React.FC<{
  isModalOnly: boolean;
}> = ({ isModalOnly, children }): JSX.Element => {
  const RFQOnlyCTAWithContext = useCallback(
    withRfq(RFQOnlyCTA as React.ComponentType, isModalOnly),
    []
  );

  return <RFQOnlyCTAWithContext childComponents={children} />;
};
